<header class="header d-flex justify-content-between align-items-center px-3 py-3 border-bottom">

  <!-- Sidebar Toggle -->
  <button
    class="d-flex align-items-center justify-content-center w-10 h-10 btn btn-outline-light toggle-icon"
    [ngClass]="{
      'bg-light': isMobileOpen$ | async
    }"
    (click)="toggleSidebar()"
    aria-label="Toggle Sidebar"
  >
    @if (isMobileOpen$ | async) {
      <!-- ❌ Close Icon -->
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.21967 7.28131C5.92678 6.98841 5.92678 6.51354 6.21967 6.22065C6.51256 5.92775 6.98744 5.92775 7.28033 6.22065L11.999 10.9393L16.7176 6.22078C17.0105 5.92789 17.4854 5.92788 17.7782 6.22078C18.0711 6.51367 18.0711 6.98855 17.7782 7.28144L13.0597 12L17.7782 16.7186C18.0711 17.0115 18.0711 17.4863 17.7782 17.7792C17.4854 18.0721 17.0105 18.0721 16.7176 17.7792L11.999 13.0607L7.28033 17.7794C6.98744 18.0722 6.51256 18.0722 6.21967 17.7794C5.92678 17.4865 5.92678 17.0116 6.21967 16.7187L10.9384 12L6.21967 7.28131Z"
          fill="currentColor"
        />
      </svg>
    } @else {
      <!-- ☰ Hamburger Icon -->
      <svg width="20" height="14" viewBox="0 0 16 12" fill="none">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.583252 1C0.583252 0.585788 0.919038 0.25 1.33325 0.25H14.6666C15.0808 0.25 15.4166 0.585786 15.4166 1C15.4166 1.41421 15.0808 1.75 14.6666 1.75L1.33325 1.75C0.919038 1.75 0.583252 1.41422 0.583252 1ZM0.583252 11C0.583252 10.5858 0.919038 10.25 1.33325 10.25L14.6666 10.25C15.0808 10.25 15.4166 10.5858 15.4166 11C15.4166 11.4142 15.0808 11.75 14.6666 11.75L1.33325 11.75C0.919038 11.75 0.583252 11.4142 0.583252 11ZM1.33325 5.25C0.919038 5.25 0.583252 5.58579 0.583252 6C0.583252 6.41421 0.919038 6.75 1.33325 6.75L7.99992 6.75C8.41413 6.75 8.74992 6.41421 8.74992 6C8.74992 5.58579 8.41413 5.25 7.99992 5.25L1.33325 5.25Z"
          fill="currentColor"
        />
      </svg>
    }
  </button>

  <!-- Right Actions -->
  <!-- Right Actions -->
  <div class="d-flex align-items-center gap-3 position-relative">

    <!-- Theme Toggle -->
    <!--<app-theme-toggle-button></app-theme-toggle-button>-->

    <!-- 🔽 Profile Dropdown -->
    <div class="position-relative">

      <!-- Trigger -->
      <button
        class="btn d-flex align-items-center gap-2 border-0"
        (click)="toggleProfileDropdown()"
      >
        <img
          src="https://i.pravatar.cc/40"
          alt="Profile"
          class="rounded-circle"
          width="36"
          height="36"
        />
        <span class="fw-medium">{{ getWelcomeText(userDetails?.userType) }}</span>
        <i
          class="bi bi-chevron-down transition-transform fw-bold"
          [ngClass]="{'rotate-180': isProfileOpen }"
        ></i>
      </button>

      <!-- Dropdown -->
      @if (isProfileOpen) {

        <div
          class="dropdown-menu show shadow-sm mt-3 end-0"
          style="min-width: 260px;"
        >
          <!-- Header -->
          <div class="px-3 py-2">
            <p class="fw-semibold">{{ userDetails?.regName }}</p>
            <small>{{ userDetails?.email }}</small>
          </div>

          <div class="dropdown-divider"></div>

          <a
            (click)="logout()" type="button"
            class="d-flex align-items-center gap-3 px-3 py-2 mt-3 rounded-lg text-decoration-none fw-medium text-secondary hover-bg"
          >
            <!-- Icon -->
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              class="icon"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.1007 19.247C14.6865 19.247 14.3507 18.9112 14.3507 18.497L14.3507 14.245H12.8507V18.497C12.8507 19.7396 13.8581 20.747 15.1007 20.747H18.5007C19.7434 20.747 20.7507 19.7396 20.7507 18.497L20.7507 5.49609C20.7507 4.25345 19.7433 3.24609 18.5007 3.24609H15.1007C13.8581 3.24609 12.8507 4.25345 12.8507 5.49609V9.74501L14.3507 9.74501V5.49609C14.3507 5.08188 14.6865 4.74609 15.1007 4.74609L18.5007 4.74609C18.9149 4.74609 19.2507 5.08188 19.2507 5.49609L19.2507 18.497C19.2507 18.9112 18.9149 19.247 18.5007 19.247H15.1007ZM3.25073 11.9984C3.25073 12.2144 3.34204 12.4091 3.48817 12.546L8.09483 17.1556C8.38763 17.4485 8.86251 17.4487 9.15549 17.1559C9.44848 16.8631 9.44863 16.3882 9.15583 16.0952L5.81116 12.7484L16.0007 12.7484C16.4149 12.7484 16.7507 12.4127 16.7507 11.9984C16.7507 11.5842 16.4149 11.2484 16.0007 11.2484L5.81528 11.2484L9.15585 7.90554C9.44864 7.61255 9.44847 7.13767 9.15547 6.84488C8.86248 6.55209 8.3876 6.55226 8.09481 6.84525L3.52309 11.4202C3.35673 11.5577 3.25073 11.7657 3.25073 11.9984Z"
              />
            </svg>

            <span>Sign out</span>
          </a>

        </div>
      }

    </div>
  </div>


</header>
